import { postApi } from "./api_instance";

export const requestPopup = async (formData, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/projects/api/request/createRequest",
      dispatch,
      sendToken: true,
      data: formData,
    });
  } catch (error) {
    throw error;
  }
};
